
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class ReportService extends ApiEvsService {
    constructor(http: Http, router: Router) {
        super(http, router);
    }

    summary(query?: any) {
        return this.get('/report/summary',query);
    }

    reportTicketSummary(query?: any) {
        return this.get('/report/ticket-summary', query)
    }

    reportContactSummary(query?: any) {
        return this.get('/report/contact-summary', query)
    }

    reportTicket(query?: any) {
        return this.get('/report/ticket', query);
    }

    reportService(query?: any) {
        return this.get('/report/ticket-service', query);
    }

    reportContact(query?: any) {
        return  this.get('/report/contact', query);
    }

    quickSummary(query?: any) {
        return this.get('/quick-summary', query);
    }
    reportChannel(query?: any) {
        return this.postServer('/omap/report/sources', query);
    }
    reportAgent(query?: any) {
      return this.postServer('/omap/report/agents', query);
    }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/services/Report.service.ts